import styled from 'styled-components';

const MainEm = styled.main`
    position: relative;
    max-width: 1280px;
    margin: 0 auto;
`;

export { MainEm };
